"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var connected_react_router_1 = require("connected-react-router");
var react_router_dom_1 = require("react-router-dom");
var translate_1 = __importDefault(require("../../../../app/localization/translate"));
var store_1 = require("../../../../app/store");
var dateUtils_1 = require("../../../../youwell-common/dateUtils");
var urls_1 = __importDefault(require("../../../../app/urls"));
var icons_1 = require("../../../../common/icons");
var arrayUtils_1 = require("../../../../youwell-common/arrayUtils");
var utils_1 = require("../utils");
var RegisterSleepMenu_1 = __importDefault(require("./RegisterSleepMenu"));
var components_1 = require("../../../../common/components");
var sleepService_1 = require("../../../../app/services/sleepService");
var DaySummaryTable_1 = __importDefault(require("./DaySummaryTable"));
var useStyles = (0, core_1.makeStyles)(function (theme) {
    var _a, _b, _c, _d, _e;
    return ({
        modalContentAndActionsWrapper: (_a = {
                display: 'flex',
                alignItems: 'center'
            },
            _a[theme.breakpoints.down('sm')] = {
                flexDirection: 'column',
            },
            _a),
        modalContent: {
            display: 'flex',
            flexDirection: 'column',
            margin: theme.spacing(1),
            '&:focus': {
                outline: 'none',
            },
        },
        top: (_b = {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                margin: theme.spacing(12, 0, 2, 0)
            },
            _b[theme.breakpoints.down('md')] = {
                margin: theme.spacing(2, 0, 2, 0),
            },
            _b),
        modalActions: (_c = {
                margin: theme.spacing(2)
            },
            _c[theme.breakpoints.down('sm')] = {
                margin: theme.spacing(0, 2, 2, 2),
                width: '75%',
            },
            _c[theme.breakpoints.down('xs')] = {
                width: '100%',
            },
            _c),
        modalActionText: {
            margin: theme.spacing(2, 0, 3, 2),
        },
        modalActionButton: (_d = {
                padding: theme.spacing(1, 4),
                marginLeft: theme.spacing(2)
            },
            _d[theme.breakpoints.down('xs')] = {
                padding: theme.spacing(1, 2),
            },
            _d),
        registerItems: (_e = {
                display: 'inline-block'
            },
            _e[theme.breakpoints.down('xs')] = {
                display: 'block',
                paddingBottom: theme.spacing(5),
            },
            _e),
        btnSection: {
            display: 'flex',
            justifyContent: 'flex-end',
            padding: theme.spacing(2, 1),
        },
        wellDoneTextAndIconWrapper: {
            display: 'flex',
        },
        thumbsUpIcon: {
            color: theme.palette.secondary.main,
            marginRight: theme.spacing(1),
        },
        wellDoneText: {
            fontWeight: 500,
        },
        fillOutMissingNightsText: {
            fontWeight: 500,
        },
        reminderInfo: {
            margin: theme.spacing(2),
        },
    });
}, { name: 'DayView' });
var DayView = function (_a) {
    var dateString = _a.date, open = _a.open, onClose = _a.onClose;
    var classes = useStyles();
    var dispatch = (0, store_1.useYouwellDispatch)();
    var translate = (0, translate_1.default)();
    var _b = React.useState(false), showReminderText = _b[0], setShowReminderText = _b[1];
    var sleepEntries = (0, store_1.useYouwellSelector)(function (state) { return (0, arrayUtils_1.sortByDateAscending)(state.sleepDataStore.entries, 'date') || []; });
    var date = React.useMemo(function () { return (0, dateUtils_1.getLocalDate)(dateString); }, [dateString]);
    var day = sleepEntries.find(function (d) { return (0, dateUtils_1.isSameDate)(d.date, date); }) || { date: date };
    var sleepLookup = (0, utils_1.getSleepLookup)(sleepEntries);
    var missingNights = (0, utils_1.missingRegistrationsLastWeek)(sleepLookup);
    var skipAllMissingNights = function () {
        missingNights.forEach(function (missingNight) {
            var sleepData = {
                entry: {
                    date: missingNight,
                    sleepProperties: {
                        userSkippedRegistering: true,
                    },
                },
            };
            (0, sleepService_1.updateSleepEntry)(dispatch, sleepData);
        });
        dispatch((0, connected_react_router_1.push)(urls_1.default.inside.pages.sleepDiary));
    };
    var edit = function () {
        onClose();
        dispatch((0, connected_react_router_1.push)("".concat(urls_1.default.inside.pages.sleepDiary, "/log/").concat((0, dateUtils_1.isoDate)(date))));
    };
    var notNow = function () {
        setShowReminderText(false);
        dispatch((0, connected_react_router_1.push)(urls_1.default.inside.pages.sleepDiary));
    };
    return (React.createElement(components_1.OverlayModal, { open: open, 
        // onClose={close} // should not be closed by clicking outside
        wide: true },
        React.createElement("div", { className: classes.modalContentAndActionsWrapper },
            React.createElement("div", { className: classes.modalContent },
                React.createElement("div", { className: classes.top },
                    React.createElement("div", null,
                        React.createElement(core_1.Typography, { variant: "h6" }, translate('sleepDiary.registration')),
                        React.createElement(core_1.Typography, { variant: "h6" }, (0, dateUtils_1.isToday)(date) ? "".concat(translate('sleepDiary.lastNight'), "  ").concat((0, dateUtils_1.longDate)(date, translate)) : (0, dateUtils_1.longDate)(date, translate))),
                    React.createElement(core_1.Button, { onClick: edit }, translate('sleepDiary.change'))),
                React.createElement(DaySummaryTable_1.default, { day: day })),
            React.createElement("div", { className: classes.modalActions }, (missingNights === null || missingNights === void 0 ? void 0 : missingNights.length) > 0 ? (React.createElement(React.Fragment, null,
                React.createElement("div", { className: classes.modalActionText }, day.totalSleepMinutes ? (React.createElement("div", { className: classes.wellDoneTextAndIconWrapper },
                    React.createElement(icons_1.ThumbUpIcon, { className: classes.thumbsUpIcon }),
                    React.createElement(core_1.Typography, { className: classes.wellDoneText }, missingNights.length === 1 ? translate('sleepDiary.dayView.wellDoneOneNightMissing') : translate('sleepDiary.dayView.wellDoneMultipleNightsMissing')))) : (React.createElement(core_1.Typography, { className: classes.fillOutMissingNightsText }, translate('sleepDiary.dayView.fillOutMissingNights')))),
                React.createElement("div", { className: classes.registerItems },
                    React.createElement(RegisterSleepMenu_1.default, { onClick: onClose, numberOfNightCards: 3 }),
                    showReminderText ? (React.createElement(React.Fragment, null,
                        React.createElement("div", { className: classes.reminderInfo },
                            React.createElement(core_1.Typography, null, translate('sleepDiary.easyToForgetDetails'))),
                        React.createElement("div", { className: classes.btnSection },
                            React.createElement(core_1.Button, { className: classes.modalActionButton, variant: "outlined", color: "secondary", onClick: skipAllMissingNights }, translate('sleepDiary.dayView.dontAskMeAgain')),
                            React.createElement(core_1.Button, { className: classes.modalActionButton, variant: "contained", color: "secondary", onClick: notNow }, translate('sleepDiary.dayView.registerLater'))))) : (React.createElement("div", { className: classes.btnSection },
                        React.createElement(core_1.Button, { className: classes.modalActionButton, variant: "outlined", color: "secondary", onClick: function () { return setShowReminderText(true); } }, translate('sleepDiary.dayView.notNow'))))))) : (React.createElement(React.Fragment, null,
                React.createElement("div", { className: classes.modalActionText },
                    React.createElement(icons_1.ThumbUpIcon, { className: classes.thumbsUpIcon }),
                    React.createElement(core_1.Typography, null, translate('sleepDiary.dayView.wellDone'))),
                React.createElement(core_1.Button, { className: classes.modalActionButton, variant: "contained", color: "primary", component: react_router_dom_1.Link, to: urls_1.default.inside.pages.sleepDiary }, translate('sleepDiary.dayView.close'))))))));
};
exports.default = DayView;
